module.exports = __webpack_public_path__ + "ea81c2e3163b1d146f469d08becab87d.jpg";